package meineglasfaser.api

import kotlinx.serialization.Serializable

@Serializable
data class ShopBasketProduct(
    val id: String,
    val quantity: Int,
) {
    @Serializable
    data class Computed(
        val id: String,
        val nid: Int,
        val title: String,
        val summary: String,
        val price: ShopPriceGroup,
        val quantity: Int,
    )
}

@Serializable
data class ShopBasketProductWithAddons(
    val product: ShopBasketProduct,
    val addons: List<ShopBasketProduct>,
) {
    @Serializable
    data class Computed(
        val product: ShopBasketProduct.Computed,
        val addons: List<ShopBasketProduct.Computed>,
    )
}

@Serializable
data class ShopBasketCoupon(
    val couponId: String,
) {
    @Serializable
    data class Computed(
        val id: String,
        // TODO
    )
}

@Serializable
data class ShopBasket(
    val products: List<ShopBasketProductWithAddons>,
    val coupons: List<ShopBasketCoupon>,
) {
    @Serializable
    data class Computed(
        val products: List<ShopBasketProductWithAddons.Computed>,
        val coupons: List<ShopBasketCoupon.Computed>,
        val totalPrice: ShopPriceGroup,
        val includesTax: Boolean,
    )
}
